<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <linearGradient
        :id="id"
        x1="1" y1="1" x2="0" y2="1"
        gradientUnits="objectBoundingBox"
      >
        <template v-if="position === 'left'">
          <stop offset="0" :stop-color="color" stop-opacity="0" />
          <stop offset="1" :stop-color="color" />
        </template>
        <template v-if="position === 'right'">
          <stop offset="0" :stop-color="color" />
          <stop offset="1" :stop-color="color" stop-opacity="0" />
        </template>
      </linearGradient>
    </defs>
    <rect :fill="`url(#${id})`"/>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      required: true
    },
    position: {
      type: String,
      required: false,
      default: 'left',
      validator: val => ['left', 'right'].includes(val)
    }
  },

  computed: {
    id() {
      return `gradient-mask-${this.position}`
    }
  }
}
</script>
